export const INFERENCE_PRICE_QUERY = `
  query GetInferencePrice($mediaType: String!, $nsfw: Boolean, $videoResolution: String) {
    inferencePrice(mediaType: $mediaType, nsfw: $nsfw, videoResolution: $videoResolution) {
      id
      mediaType
      nsfw
      videoResolution
      provider
      characterUnit
      durationUnit
      audio
      credits
      enabled
      createdAt
      updatedAt
    }
  }
`;

export const INFERENCE_PRICES_QUERY = `
  query GetInferencePrices($mediaType: String, $nsfw: Boolean, $videoResolution: String) {
    inferencePrices(mediaType: $mediaType, nsfw: $nsfw, videoResolution: $videoResolution) {
      id
      mediaType
      nsfw
      videoResolution
      provider
      characterUnit
      durationUnit
      audio
      credits
      enabled
      createdAt
      updatedAt
    }
  }
`;
